<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-assunto-agrovisita') {
            next({ name: 'agro-assunto-agrovisita-list' });
        } else if (to.name == 'ven-assunto-agrovisita') {
            next({ name: 'ven-assunto-agrovisita-list' });
        }
        {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-assunto-agrovisita') {
            this.$router.push({ name: 'agro-assunto-agrovisita-list' });
        } else if (this.$route.name == 'ven-assunto-agrovisita') {
            this.$router.push({ name: 'ven-assunto-agrovisita-list' });
        }
    },
};
</script>
